"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint no-redeclare: "off" */
/*globals MutationObserver:false*/
var toc_html_1 = __importDefault(require("./toc.html"));
require("./toc.less");
(function (module) {
    'use strict';
    var TOC_SELECTOR = '.pr-toc', TOC_PAGE_SELECTOR = '.pr-toc-page', TOC_PAGE_CONTAINER_SELECTOR = '.pr-toc-container', PR_PAGE_SELECTOR = '.pr-page', 
    //FILEBAR_SELECTOR = '.pr-filebar',
    //TOOLBAR_SELECTOR = '.pr-toolbar',
    REMOVED_CLASS = 'removed';
    TOCController.$inject = [
        '$templateCache',
        '$timeout',
        '$window',
        'prFlowingPages',
        'prScrollService',
        'prViewOptions'
    ];
    function TOCController($templateCache, $timeout, $window, flowingPages, scrollService, viewOptions) {
        var $ctrl = this, observers = {}, pageCount = 1;
        angular.extend($ctrl, {
            $onInit: function () {
                startWatchingPageScroll();
                $(TOC_SELECTOR).on('mouseenter', stopWatchingPageScroll);
                $(TOC_SELECTOR).on('mouseleave', startWatchingPageScroll);
                $timeout(function () {
                    $($window).on('resize', onWindowResize);
                    setVisiblePages();
                    selectTocPage($ctrl.activePage || 0);
                });
            },
            $doCheck: function () {
                // We do this check so that we draw any new pages in the visible range
                var newCount = $ctrl.getPages().length;
                if (newCount !== pageCount) {
                    pageCount = newCount;
                    $timeout(function () {
                        updateObservers($ctrl.activePage || 0);
                    });
                }
            },
            $onDestroy: function () {
                stopWatchingPageScroll();
                $(TOC_SELECTOR).off('mouseenter', stopWatchingPageScroll);
                $(TOC_SELECTOR).off('mouseleave', startWatchingPageScroll);
                $($window).off('resize', onWindowResize);
            },
            $onChanges: function (changes) {
                if (changes.activePage) {
                    selectTocPage(changes.activePage.currentValue);
                }
            },
            getPages: function () {
                return flowingPages.getPages();
            },
            getPageOptionsMenu: function (page, pageIndex) {
                return [{
                        label: 'Remove Page',
                        icon: 'icon-x-sm',
                        replaceCheck: true,
                        action: function () {
                            removePage(page, pageIndex);
                        }
                    }];
            },
            goToPage: function ($index) {
                $ctrl.bdyCtrl.setActivePage($index);
            }
        });
        var onWindowResize = _.debounce(function () {
            toggleToc();
            setVisiblePages();
        }, 100);
        function startWatchingPageScroll() {
            scrollService.onScroll(onPageScroll);
        }
        function stopWatchingPageScroll() {
            scrollService.offScroll(onPageScroll);
        }
        function toggleToc() {
            var tooSmall = ($(PR_PAGE_SELECTOR).offset().left <= $(TOC_PAGE_CONTAINER_SELECTOR).width());
            viewOptions.showToc(!tooSmall);
        }
        function setVisiblePages() {
            //var tocPageHeight = $(TOC_PAGE_CONTAINER_SELECTOR).height(),
            //windowHeight = $window.innerHeight,
            //filebarHeight = $(FILEBAR_SELECTOR).height(),
            //toolbarHeight = $(TOOLBAR_SELECTOR).height(),
            //countOfTocPage = Math.ceil((windowHeight - filebarHeight - toolbarHeight) / tocPageHeight) || 2;
            //$ctrl.bdyCtrl.setVisiblePages(Math.max(countOfTocPage, 2));
        }
        function getTocPages() {
            return $(TOC_SELECTOR).children();
        }
        function getTocPage(idx) {
            return getTocPages().eq(idx);
        }
        function getTocPageContent(idx) {
            return getTocPage(idx).find(TOC_PAGE_SELECTOR);
        }
        function selectTocPage(idx) {
            var tocPages = getTocPages();
            if (tocPages.length <= idx) {
                return;
            }
            tocPages.filter('.selected').removeClass('selected');
            tocPages.eq(idx).addClass('selected');
            updateObservers(idx);
        }
        // updates all the pages that we should be watching with observers
        function updateObservers(idx) {
            var total = $ctrl.visiblePages + 2, start = Math.max(Math.min(idx - 1, pageCount - total), 0), end = start + total;
            for (var i = 0; i < pageCount; i++) {
                if (i < start || i > end) {
                    stopObserver(i);
                }
                else {
                    startObserver(i);
                }
            }
        }
        function startObserver(pageIdx) {
            if (!observers[pageIdx]) {
                drawPreview(pageIdx);
                observers[pageIdx] = new MutationObserver(_.throttle(function () {
                    drawPreview(pageIdx);
                }, 10));
            }
            observers[pageIdx].observe(getReportPageContent(pageIdx), {
                attributes: true,
                childList: true,
                subtree: true,
                characterData: true
            });
        }
        function stopObserver(pageIdx) {
            if (observers[pageIdx]) {
                observers[pageIdx].disconnect();
                delete observers[pageIdx];
            }
            // delete the content for the sake of the DOM!
            getTocPageContent(pageIdx).empty();
        }
        /*
         * Draws a preview of the passedIn page
         */
        function drawPreview(idx) {
            var page = getTocPageContent(idx);
            page.empty();
            page.append(clonePage(idx));
        }
        function clonePage(idx) {
            var content = getReportPageContent(idx), cloned = '';
            if (content) {
                cloned = content.cloneNode(true);
                updateCanvasNodes(cloned, content);
            }
            return $(cloned);
        }
        function onPageScroll(evt, scrollTop, scrollHeight) {
            var toc = $(TOC_SELECTOR), scale = toc[0].scrollHeight / scrollHeight, top = scrollTop * scale - 88;
            toc.scrollTop(top);
        }
        function getReportPageContent(idx) {
            return $(PR_PAGE_SELECTOR).eq(idx)[0];
        }
        function removePage(page, idx) {
            var pageDom = getTocPages().eq(idx);
            pageDom.addClass(REMOVED_CLASS);
        }
        /*
         * When cloning the dom, canvas nodes don't copy over their content, so we have to do it manually
         * note: the wordcloud uses canvas
         */
        function updateCanvasNodes(cloned, orig) {
            var clonedCanvases = cloned.querySelectorAll('canvas');
            if (!clonedCanvases || !clonedCanvases.length) {
                return;
            }
            var origCanvases = orig.querySelectorAll('canvas');
            origCanvases.forEach(function (canvas, i) {
                var cloned = clonedCanvases[i];
                if (cloned && cloned.getContext) {
                    cloned.getContext('2d').drawImage(canvas, 0, 0);
                }
            });
        }
    }
    module.component('prToc', {
        templateUrl: toc_html_1.default,
        controller: TOCController,
        bindings: {
            activePage: '<',
            visiblePages: '<'
        },
        require: {
            bdyCtrl: '^^prBody'
        }
    });
}(angular.module('qualtrics.pr')));
